export class Dtos {

  public static USER = {
    SimpleUserDTO: "SimpleUserDTO",
    SubscribedUserDTO: "SubscribedUserDTO",
    UserReviewDTO: "UserReviewDTO"
  };

  public static ORDER = {
    DashboardAnalyticsOrderDTO: "DashboardAnalyticsOrderDTO",
    OrderForDashboardDTO: "OrderForDashboardDTO"
  };

  public static DIY = {
    DiyDTO: "DiyDTO",
    IngredientDTO: "IngredientDTO",
    SpecialDietDTO: "SpecialDietDTO",
    NecessaryEquipmentDTO: "NecessaryEquipmentDTO"
  };

  public static VOUCHER = {
    DashboardAnalyticsVoucherDTO: "DashboardAnalyticsVoucherDTO",
    VoucherToDashboardListDTO: "VoucherToDashboardListDTO"
  };

  public static PRODUCT = {
    ProductDTO: "ProductDTO",
    LocalizedProductDTO: "LocalizedProductDTO",
    ProductForDashboardListDTO: "ProductForDashboardListDTO",
    LocalizationsAndMinPurchaseAmountProductDTO: "LocalizationsAndMinPurchaseAmountProductDTO"
  };

  public static DIY_TYPE = {
    DiyTypeDTO: "DiyTypeDTO",
    SlimDiyTypeDTO: "SlimDiyTypeDTO"
  };

  public static CUISINE = {
    CuisineDTO: "CuisineDTO"
  };

  public static ALLERGEN = {
    AllergenDTO: "AllergenDTO"
  };

  public static DRINK = {
    DrinkDTO: "DrinkDTO",
    SimpleDrinkDTO: "SimpleDrinkDTO"
  };

  public static DRINK_CATEGORY = {
    DrinkCategoryDTO: "DrinkCategoryDTO"
  };

  public static ATTACHMENT = {
    AttachmentDTO: "AttachmentDTO"
  };

  public static RESTAURANT = {
    DashboardOpenedRestaurantDTO: "DashboardOpenedRestaurantDTO",
    StaffDTO: "StaffDTO",
    PlaceDTO: "PlaceDTO",
    StaffTypeDTO: "StaffTypeDTO",
    SimpleCarteForDashboardRestaurantDTO: "SimpleCarteForDashboardRestaurantDTO",
    SimpleDrinkCarteForDashboardRestaurantDTO: "SimpleDrinkCarteForDashboardRestaurantDTO",
    OpeningHoursDTO: "OpeningHoursDTO",
    OpeningHoursForDashboardDTO: "OpeningHoursForDashboardDTO",
    ClosingHoursDTO: "ClosingHoursDTO",
    RestaurantForDashboardListDTO: "RestaurantForDashboardListDTO"
  };

  public static RESERVATION = {
    ReservationForDashboardCalendarDTO: 'ReservationForDashboardCalendarDTO',
    ReservationForRestaurantAppDTO: 'ReservationForRestaurantAppDTO',
    ReservationForDashboardNotificationDTO: 'ReservationForDashboardNotificationDTO',
    EventDTO: 'EventDTO'
  };

  public static DISCOUNT = {
    DiscountDTO: "DiscountDTO",
    DiscountForDashBoardListDTO: "DiscountForDashBoardListDTO"
  };

  public static EVENT_LOG = {
    VoucherLogDTO: "VoucherLogDTO",
    ProductLogDTO: "ProductLogDTO",
    RestaurantLogDTO: "RestaurantLogDTO",
    SchedulerLogDTO: "SchedulerLogDTO",
    ReservationLogDTO: "ReservationLogDTO",
    EventLogDTO: "EventLogDTO",
    EventBaseLogDTO: "EventBaseLogDTO"
  };

  public static MENUITEM = {
    MenuItemDTO: "MenuItemDTO",
    MenuItemWithoutBaseAttributesDTO: "MenuItemWithoutBaseAttributesDTO"
  };

  public static COMPANY = {
    CompanyDTO: "CompanyDTO"
  };

  public static CARTE_PATTERN = {
    DiyCartePatternDTO: "DiyCartePatternDTO",
    DrinkCartePatternDTO: "DrinkCartePatternDTO"
  };

  public static SLOT = {
    DiySlotDTO: "DiySlotDTO",
    DrinkSlotDTO: "DrinkSlotDTO"
  };

  public static SYSTEM_LISTS = {
    DrinkCategoryDTO: "DrinkCategoryDTO",
    DocumentCategoryDTO: "DocumentCategoryDTO",
    IngredientTypeDTO: "IngredientTypeDTO",
    NecessaryEquipmentTypeDTO: "NecessaryEquipmentTypeDTO",
    ProductLevelDTO: "ProductLevelDTO"
  };

  public static CORE_DATA = {
    languages: "SlimCoreLanguageDTO",
    currencies: "SlimCoreCurrencyDTO",
    localizations: "SlimCoreLocalizationDTO"
  };

  public static FEES = {
    FeeHistoryDTO: "FeeHistoryDTO"
  };

  public static SUPPORTS = {
    SupportDTO: "SupportDTO"
  };

  public static RECIPE = {
    RecipeDTO: "RecipeDTO"
  };

  public static VIDEO_EVENT = {
    VideoEventDTO: "VideoEventDTO"
  };

  public static VIDEO_SEGMENT = {
    VideoSegmentDTO: "VideoSegmentDTO"
  }
}
